import {useUxStore} from "@/stores/uxStore";
import apiClient from "@/axiosConfig";
import Qs from 'qs';
import { extractApiErrorMessage } from "@/utils/apiErrorUtils";

// Helper function to get the store instance
const getUxStore = () => useUxStore();

export default {
    async getZUGFeRDs(filter = {}) {
        try {
            getUxStore().startLoading()
            const response = await apiClient.get('/zugferd', {
                params: {...filter}, paramsSerializer: (params) => {
                    return Qs.stringify(params, {arrayFormat: 'repeat'});
                }
            });
            return response;
        } catch (error) {
            console.error("Error in ZUGFeRDService.getZUGFeRDs:", error);
            getUxStore().setError("Error fetching ZUGFeRD list");
            console.log(error);
        } finally {
            getUxStore().stopLoading();
        }
    },

    async getZUGFeRD(id) {
        try {
            const response = await apiClient.get(`/zugferd/${id}`);
            // console.log("API response data:", response.data); // Debugging output to confirm API response structure
            return response.data;
        } catch (error) {
            console.error("Error in ZUGFeRDService.getZUGFeRD:", error);
            getUxStore().setError("Error fetching ZUGFeRD data");
            throw error;
        }
    },

    async createZUGFeRD(zugferdData) {
        try {
            return await apiClient.post('/zugferd', zugferdData);
        } catch (error) {
            console.error("Error in ZUGFeRDService.createZUGFeRD:", error);
            if (error.request && !error.response) {
                // The request was made, but no response was received
                getUxStore().setError("No response from server. Please try again later.");
            } else {
                getUxStore().setError(extractApiErrorMessage(error, "Fehler beim Erstellen der XRechnung."));
            }
            console.log(error);
            throw error;
        }
    },

    async editZUGFeRD(id, zugferdData) {
        try {
            return await apiClient.put(`/zugferd/${id}`, zugferdData);
        } catch (error) {
            console.error("Error in ZUGFeRDService.editZUGFeRD:", error);
            getUxStore().setError(extractApiErrorMessage(error, "Fehler beim Aktualisieren der XRechnung."));
            console.log(error);
            throw error;
        }
    },

    async deleteZUGFeRD(id) {
        try {
            return await apiClient.delete(`/zugferd/${id}`);
        } catch (error) {
            console.error("Error in ZUGFeRDService.deleteZUGFeRD:", error);
            getUxStore().setError("Error deleting ZUGFeRD entry");
            throw error;
        }
    },

    async downloadZUGFeRD(fileId) {
        try {
            return await apiClient.get(`/file/download/${fileId}`, {responseType: 'arraybuffer'});
        } catch (error) {
            console.error("Error in ZUGFeRDService.downloadZUGFeRD:", error);
            getUxStore().setError("Error downloading ZUGFeRD file");
            throw error;
        }
    },

    async viewZUGFeRD(fileId) {
        try {
            return await apiClient.get(`/Transform/PDF/TO/HTML/${fileId}`, {responseType: 'blob'});
        } catch (error) {
            console.error("Error in ZUGFeRDService.viewZUGFeRD:", error);
            getUxStore().setError("Error viewing ZUGFeRD file");
            throw error;
        }
    },

    async validateZUGFeRD(id, validatorMode = null) {
        try {
            const params = {};
            if (validatorMode) {
                params.validatorMode = validatorMode;
            }

            return await apiClient.get(`/ZUGFeRD/${id}/validate`, { params });
        } catch (error) {
            console.error("Error in ZUGFeRDService.validateZUGFeRD:", error);
            getUxStore().setError(extractApiErrorMessage(error, "Fehler beim Validieren der XRechnung."));
            throw error;
        }
    }
};
